import React, { useEffect } from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "styled-components";
import axios from "axios";
import Web3 from "web3";
import { Button, Input as _Input, Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup } from "reactstrap";

// import ReactGA from "react-ga";
import Routes from "./Components/Routes";
import { HOST, NODE_ENDPOINT, GAS_PRICE_API, CHAIN_ID, CHAIN_NAME } from "./Utils/constants";
import Theme from "./Styles/Theme";
import GlobalContext from "./Hooks/globalContext";
import useState from "./Hooks/useState";
import GlobalStyles from "./Styles/GlobalStyle";
import languagePack from "./Utils/language";

const Wrapper = styled.div`
  height: 100%;
`;

const InnerWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const web3 = new Web3(
  new Web3.providers.HttpProvider(NODE_ENDPOINT, {
    headers: [],
  })
);

// ReactGA.initialize("UA-161528891-1");

const App = () => {
  const getLanguage = (myLanguage) => {
    switch (myLanguage) {
      default:
        return "korean";
    }
  };

  const imageHandler = useState(true);
  const isLogin = useState(
    (localStorage.getItem("token") ? true : false) || (sessionStorage.getItem("token") ? true : false)
  );
  const device = useState(null);
  const modal = useState(false);
  const isSession = useState(sessionStorage.getItem("token") ? true : localStorage.getItem("token") ? false : null);
  const user = useState(null);
  const historyFunction = useState(false);
  const language = useState(getLanguage(navigator.language.substring(0, 2)));
  const sidebar = useState(false);
  const pushToken = useState(null);

  const logout = () => {
    isLogin.setState(false);
    user.setState({});
    if (isSession.state) {
      sessionStorage.removeItem("token");
    } else {
      localStorage.removeItem("token");
    }
  };

  const setLanguage = ({ target }) => {
    if (target.value !== "") {
      language.setState(target.value);
    }
  };

  const httpHeader = (token = null) => {
    const httpHeader = {
      headers: {
        Authorization: `Bearer ${
          token
            ? token
            : sessionStorage.getItem("token")
            ? sessionStorage.getItem("token")
            : localStorage.getItem("token")
        }`,
      },
    };
    return httpHeader;
  };

  const getUser = async (token = null) => {
    try {
      const me = await axios.post(`${HOST}/user/info`, { detail: true }, httpHeader(token));
      user.setState(me.data.user);
      return me.data.user;
    } catch (e) {
      if (e.message === "Request failed with status code 401") {
        isLogin.setState(false);
        user.setState({});
        if (isSession.state) {
          sessionStorage.removeItem("token");
        } else {
          localStorage.removeItem("token");
        }
        return "expired";
      }
    }
  };

  const sendTx = async (address, confirm, reject, isLoading) => {
    const count = await getTxCount(address);
    const {
      data: { fast, fastest, safeLow, average },
    } = await axios.post(GAS_PRICE_API);

    const gasPrice = (fastest / 10).toString();
    const weiGasPrice = web3.utils.toWei(gasPrice, "gwei");
    const hexGasPrice = web3.utils.toHex(weiGasPrice);
    const amount = await getBalance(address);
    const convertedGas = web3.utils.fromWei("21000", "gwei");
    const realAmount = amount - convertedGas * gasPrice * 2;
    const {
      data: { adminAddress },
    } = await axios.post(`${HOST}/api/config`, { column: "adminAddress" }, httpHeader());
    const requestBody = {
      rawTransaction: {
        from: address,
        gasPrice: hexGasPrice,
        gasLimit: web3.utils.toHex(21000),
        to: adminAddress,
        value: web3.utils.toHex(web3.utils.toWei(realAmount.toString(), "ether")),
        chainId: web3.utils.toHex(CHAIN_ID),
        nonce: web3.utils.toHex(count),
      },
      CHAIN_NAME,
      realAmount,
    };
    const { data } = await axios.post(`${HOST}/wallet/exchange/eth`, requestBody, httpHeader());
    if (data.status) {
      modal.setState(confirm);
    } else {
      modal.setState(reject);
    }
    isLoading.setState(false);
  };

  const getTxCount = async (address) => {
    const count = await web3.eth.getTransactionCount(address, "pending");
    return count;
  };

  const getBalance = async (address) => {
    const balance = await web3.eth.getBalance(address ? address : user.state.address, "pending");
    const convertedBalance = web3.utils.fromWei(balance);
    return Number(convertedBalance);
  };

  const balanceConvert = (eth) => {
    try {
      const numberEth = Number(eth);
      const converted = numberEth.toFixed(9);
      const result = converted.substring(0, converted.length - 1);
      return Number(result);
    } catch (e) {
      return eth;
    }
  };

  const sidebarToggle = () => {
    sidebar.setState(!sidebar.state);
  };

  const preload = () => {
    const pcDevice = "win16|win32|win64|mac|macintel";
    if (navigator.platform) {
      if (pcDevice.indexOf(navigator.platform.toLowerCase()) < 0) {
        const userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.search("android") > -1) {
          device.setState("android");
        } else if (userAgent.search("iphone") > -1 || userAgent.search("ipod") > -1 || userAgent.search("ipad") > -1) {
          device.setState("ios");
        } else {
          device.setState("mobile");
        }
      } else {
        device.setState("pc");
      }
    }

    window.addEventListener("message", function (event) {
      if (event.data && event.data !== "undefined") {
        try {
          const parsed = JSON.parse(event.data);
          pushToken.setState(parsed.pushToken);
        } catch (e) {}
      }
    });
    document.addEventListener("message", function (event) {
      if (event.data && event.data !== "undefined") {
        try {
          const parsed = JSON.parse(event.data);
          pushToken.setState(parsed.pushToken);
        } catch (e) {}
      }
    });
    if (!user.state && isLogin.state) {
      getUser();
    }
  };

  const toggleModal = ({ text }) => {
    modal.setState(text ? text : null);
  };

  const inputOnFucus = () => {
    if (device.state === "android") {
      imageHandler.setState(false);
    }
  };

  const inputOnBlur = () => {
    if (device.state === "android") {
      imageHandler.setState(true);
    }
  };

  useEffect(() => {
    preload();
  }, []);

  const contextValue = {
    inputOnFucus,
    inputOnBlur,
    imageHandler,
    isLogin,
    toggleModal,
    modal,
    user,
    getUser,
    logout,
    historyFunction,
    language,
    setLanguage,
    httpHeader,
    web3,
    getTxCount,
    balanceConvert,
    getBalance,
    isSession,
    sidebarToggle,
    sendTx,
    pushToken,
  };
  return (
    <>
      <GlobalStyles />
      <GlobalContext.Provider value={contextValue}>
        <ThemeProvider theme={Theme}>
          <Router>
            <Helmet>
              <meta name="viewport" content="initial-scale=1.0,user-scalable=no,maximum-scale=1,width=device-width" />
            </Helmet>
            <div>
              <Modal centered={true} isOpen={!!modal.state} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{languagePack("알림", language.state)}</ModalHeader>
                <ModalBody>{modal.state}</ModalBody>
                <ModalFooter>
                  <Button style={{ backgroundColor: Theme.mainColor }} onClick={toggleModal}>
                    {languagePack("확인", language.state)}
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
            <Wrapper>
              <InnerWrapper>
                <Routes />
              </InnerWrapper>
            </Wrapper>
          </Router>
        </ThemeProvider>
      </GlobalContext.Provider>
    </>
  );
};

export default App;

const sidebarStyle = {
  sidebar: {
    zIndex: 10,
    width: "90%",
    background: "#EDF5FF",
    boxShadow: "rgba(0, 0, 0, 0.15) 4px 4px 8px",
  },
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  overlay: {
    display: "flex",
    justifyContent: "center",
    zIndex: 1,
    width: "90%",
  },
};
